import { hoursToDays } from './units.js';

/**
 * Colonnes de l'export Time tracking (Excel et CSV), unité respectée.
 *
 * Ticket support #29 (décision 2026-10-29) : en jours, l'export porte la
 * valeur EXACTE (heures ÷ 8, ex. 7 h → 0,875 j), sans l'arrondi à 1 décimale
 * de l'écran. Valeur numérique (cellule nombre dans Excel).
 *
 * @param {'hours'|'days'} unit
 */
export function timetrackingExportColumns(unit) {
  const isDays = unit === 'days';
  return [
    { key: 'personName', label: 'Personne' },
    { key: 'affaireName', label: 'Projet' },
    { key: 'taskName', label: 'Tâche' },
    { key: 'phaseName', label: 'Phase' },
    { key: 'date', label: 'Date' },
    {
      key: 'hours',
      label: isDays ? 'Jours' : 'Heures',
      format: (v) => (v == null ? null : isDays ? hoursToDays(v) : v),
    },
    { key: 'billable', label: 'Facturable', format: (v) => (v ? 'Oui' : 'Non') },
    { key: 'notes', label: 'Notes' },
  ];
}
